import { __assign } from "tslib";
import { alpha, createTheme } from '@mui/material';
import AccordionTheme from '@components/accordion/theme';
import AccordionActionsTheme from '@components/accordion-actions/theme';
import AccordionDetailsTheme from '@components/accordion-details/theme';
import AccordionSummaryTheme from '@components/accordion-summary/theme';
import AlertTheme from '@components/alert/theme';
import AlertTitleTheme from '@components/alert-title/theme';
import AppBarTheme from '@components/app-bar/theme';
import AutocompleteTheme from '@components/autocomplete/theme';
import AvatarTheme from '@components/avatar/theme';
import AvatarGroupTheme from '@components/avatar-group//theme';
import BackdropTheme from '@components/backdrop/theme';
import BadgeTheme from '@components/badge/theme';
import BottomNavigationTheme from '@components/bottom-navigation/theme';
import BottomNavigationActionTheme from '@components/bottom-navigation-action/theme';
import BreadcrumbsTheme from '@components/breadcrumbs/theme';
import ButtonTheme from '@components/button/theme';
import ButtonBaseTheme from '@components/button-base/theme';
import ButtonGroupTheme from '@components/button-group/theme';
import CardTheme from '@components/card/theme';
import CardActionAreaTheme from '@components/card-action-area/theme';
import CardActionsTheme from '@components/card-actions/theme';
import CardContentTheme from '@components/card-content/theme';
import CardHeaderTheme from '@components/card-header/theme';
import CardMediaTheme from '@components/card-media/theme';
import CheckboxTheme from '@components/checkbox/theme';
import ChipTheme from '@components/chip/theme';
import FilledInputTheme from '@components/filled-input/theme';
import FormControlTheme from '@components/form-control/theme';
import FormControlLabelTheme from '@components/form-control-label/theme';
import FormGroupTheme from '@components/form-group/theme';
import FormHelperTextTheme from '@components/form-helper-text/theme';
import FormLabelTheme from '@components/form-label/theme';
import IconButtonTheme from '@components/icon-button/theme';
import TextFieldTheme from '@components/text-field/theme';
import InputTheme from '@components/input/theme';
import InputBaseTheme from '@components/input-base/theme';
import InputAdornmentTheme from '@components/input-adornment/theme';
import InputLabelTheme from '@components/input-label/theme';
import ListTheme from '@components/list/theme';
import ListItemTheme from '@components/list-item/theme';
import ListItemTextTheme from '@components/list-item-text/theme';
import ListSubheaderTheme from '@components/list-subheader/theme';
import ListItemAvatarTheme from '@components/list-item-avatar/theme';
import ListItemSecondaryActionTheme from '@components/list-item-secondary-action/theme';
import ListItemIconTheme from '@components/list-item-icon/theme';
import ListItemButtonTheme from '@components/list-item-button/theme';
import MenuTheme from '@components/menu/theme';
import MenuItemTheme from '@components/menu-item/theme';
import MenuListTheme from '@components/menu-list/theme';
import OutlinedInputTheme from '@components/outlined-input/theme';
import RadioTheme from '@components/radio/theme';
import RadioGroupTheme from '@components/radio-group/theme';
import SelectTheme from '@components/select/theme';
import SwitchTheme from '@components/switch/theme';
import TableTheme from '@components/table/theme';
import TableBodyTheme from '@components/table-body/theme';
import TableCellTheme from '@components/table-cell/theme';
import TableContainerTheme from '@components/table-container/theme';
import TableFooterTheme from '@components/table-footer/theme';
import TableHeadTheme from '@components/table-head/theme';
import TablePaginationTheme from '@components/table-pagination/theme';
import TableRowTheme from '@components/table-row/theme';
import TableSortLabelTheme from '@components/table-sort-label/theme';
import CircularProgressTheme from '@components/circular-progress/theme';
import LinearProgressTheme from '@components/linear-progress/theme';
import CollapseTheme from '@components/collapse/theme';
import ContainerTheme from '@components/container/theme';
import DividerTheme from '@components/divider/theme';
import DialogTheme from '@components/dialog/theme';
import DialogActionsTheme from '@components/dialog-actions/theme';
import DialogContentTheme from '@components/dialog-content/theme';
import DialogContentTextTheme from '@components/dialog-content-text/theme';
import DialogTitleTheme from '@components/dialog-title/theme';
import ToolbarTheme from '@components/toolbar/theme';
import DrawerTheme from '@components/drawer/theme';
import FabTheme from '@components/fab/theme';
import GridTheme from '@components/grid/theme';
import ImageListTheme from '@components/image-list/theme';
import ImageListItemTheme from '@components/image-list-item/theme';
import ImageListItemBarTheme from '@components/image-list-item-bar/theme';
import LinkTheme from '@components/link/theme';
import ModalTheme from '@components/modal/theme';
import NativeSelectTheme from '@components/native-select/theme';
import PaginationTheme from '@components/pagination/theme';
import PaginationItemTheme from '@components/pagination-item/theme';
import PaperTheme from '@components/paper/theme';
import PopperTheme from '@components/popper/theme';
import PopoverTheme from '@components/popover/theme';
import RatingTheme from '@components/rating/theme';
import SkeletonTheme from '@components/skeleton/theme';
import SliderTheme from '@components/slider/theme';
import SnackbarTheme from '@components/snackbar/theme';
import SnackbarContentTheme from '@components/snackbar-content/theme';
import StackTheme from '@components/stack/theme';
import SpeedDialTheme from '@components/speed-dial/theme';
import SpeedDialActionTheme from '@components/speed-dial-action/theme';
import SpeedDialIconTheme from '@components/speed-dial-icon/theme';
import StepTheme from '@components/step/theme';
import StepButtonTheme from '@components/step-button/theme';
import StepConnectorTheme from '@components/step-connector/theme';
import StepContentTheme from '@components/step-content/theme';
import StepIconTheme from '@components/step-icon/theme';
import StepLabelTheme from '@components/step-label/theme';
import StepperTheme from '@components/stepper/theme';
import SvgIconTheme from '@components/svg-icon/theme';
import SwipeableDrawerTheme from '@components/swipeable-drawer/theme';
import TabTheme from '@components/tab/theme';
import TabsTheme from '@components/tabs/theme';
import ToggleButtonTheme from '@components/toggle-button/theme';
import ToggleButtonGroupTheme from '@components/toggle-button-group/theme';
import { TypographyTheme } from '@components/typography/theme';
import { typography } from './typography';
import { palette } from './palette';
export var defaultTheme = {
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl", "xxl"],
        values: {
            xs: 0,
            sm: 600,
            md: 840,
            lg: 1024,
            xl: 1280,
            xxl: 1440,
        },
    },
    palette: palette,
    typography: typography,
    // spacing: (factor: number) => {
    //   const isSmallScreen = useMediaQuery('(max-width:600px)');
    //   return isSmallScreen ? `${factor * 0.438}rem` : `${factor * 0.5}rem`;
    // },
    // spacing: (factor: number) => {
    //   const isSmallScreen = useMediaQuery('(max-width:600px)');
    //   return isSmallScreen ? `${factor * 7}px` : `${factor * 8}px`;
    // },
    shape: {
        borderRadius: 3,
    },
};
export var overrideComponents = function (theme) {
    return {
        MuiAccordion: __assign({}, AccordionTheme(theme)),
        MuiAccordionActions: __assign({}, AccordionActionsTheme(theme)),
        MuiAccordionDetails: __assign({}, AccordionDetailsTheme(theme)),
        MuiAccordionSummary: __assign({}, AccordionSummaryTheme(theme)),
        MuiAlert: __assign({}, AlertTheme(theme)),
        MuiAlertTitle: __assign({}, AlertTitleTheme(theme)),
        MuiAppBar: __assign({}, AppBarTheme(theme)),
        MuiAutocomplete: __assign({}, AutocompleteTheme(theme)),
        MuiAvatar: __assign({}, AvatarTheme(theme)),
        MuiAvatarGroup: __assign({}, AvatarGroupTheme(theme)),
        MuiBackdrop: __assign({}, BackdropTheme(theme)),
        MuiBadge: __assign({}, BadgeTheme(theme)),
        MuiBottomNavigation: __assign({}, BottomNavigationTheme(theme)),
        MuiBottomNavigationAction: __assign({}, BottomNavigationActionTheme(theme)),
        MuiBreadcrumbs: __assign({}, BreadcrumbsTheme(theme)),
        MuiButton: __assign({}, ButtonTheme(theme)),
        MuiButtonBase: __assign({}, ButtonBaseTheme(theme)),
        MuiButtonGroup: __assign({}, ButtonGroupTheme(theme)),
        MuiCard: __assign({}, CardTheme(theme)),
        MuiCardActionArea: __assign({}, CardActionAreaTheme(theme)),
        MuiCardActions: __assign({}, CardActionsTheme(theme)),
        MuiCardContent: __assign({}, CardContentTheme(theme)),
        MuiCardHeader: __assign({}, CardHeaderTheme(theme)),
        MuiCardMedia: __assign({}, CardMediaTheme(theme)),
        MuiCheckbox: __assign({}, CheckboxTheme(theme)),
        MuiChip: __assign({}, ChipTheme(theme)),
        MuiCircularProgress: __assign({}, CircularProgressTheme(theme)),
        MuiCollapse: __assign({}, CollapseTheme(theme)),
        MuiContainer: __assign({}, ContainerTheme(theme)),
        MuiDialog: __assign({}, DialogTheme(theme)),
        MuiDialogActions: __assign({}, DialogActionsTheme(theme)),
        MuiDialogContent: __assign({}, DialogContentTheme(theme)),
        MuiDialogContentText: __assign({}, DialogContentTextTheme(theme)),
        MuiDialogTitle: __assign({}, DialogTitleTheme(theme)),
        MuiDivider: __assign({}, DividerTheme(theme)),
        MuiDrawer: __assign({}, DrawerTheme(theme)),
        MuiFab: __assign({}, FabTheme(theme)),
        MuiFilledInput: __assign({}, FilledInputTheme(theme)),
        MuiFormControl: __assign({}, FormControlTheme(theme)),
        MuiFormControlLabel: __assign({}, FormControlLabelTheme(theme)),
        MuiFormGroup: __assign({}, FormGroupTheme(theme)),
        MuiFormHelperText: __assign({}, FormHelperTextTheme(theme)),
        MuiFormLabel: __assign({}, FormLabelTheme(theme)),
        MuiGrid: __assign({}, GridTheme(theme)),
        MuiIconButton: __assign({}, IconButtonTheme(theme)),
        MuiImageList: __assign({}, ImageListTheme(theme)),
        MuiImageListItem: __assign({}, ImageListItemTheme(theme)),
        MuiImageListItemBar: __assign({}, ImageListItemBarTheme(theme)),
        MuiInput: __assign({}, InputTheme(theme)),
        MuiInputAdornment: __assign({}, InputAdornmentTheme(theme)),
        MuiInputBase: __assign({}, InputBaseTheme(theme)),
        MuiInputLabel: __assign({}, InputLabelTheme(theme)),
        MuiLinearProgress: __assign({}, LinearProgressTheme(theme)),
        MuiLink: __assign({}, LinkTheme(theme)),
        MuiList: __assign({}, ListTheme(theme)),
        MuiListItem: __assign({}, ListItemTheme(theme)),
        MuiListItemAvatar: __assign({}, ListItemAvatarTheme(theme)),
        MuiListItemButton: __assign({}, ListItemButtonTheme(theme)),
        MuiListItemIcon: __assign({}, ListItemIconTheme(theme)),
        MuiListItemSecondaryAction: __assign({}, ListItemSecondaryActionTheme(theme)),
        MuiListItemText: __assign({}, ListItemTextTheme(theme)),
        MuiListSubheader: __assign({}, ListSubheaderTheme(theme)),
        MuiMenu: __assign({}, MenuTheme(theme)),
        MuiMenuItem: __assign({}, MenuItemTheme(theme)),
        MuiMenuList: __assign({}, MenuListTheme(theme)),
        MuiModal: __assign({}, ModalTheme(theme)),
        MuiNativeSelect: __assign({}, NativeSelectTheme(theme)),
        MuiOutlinedInput: __assign({}, OutlinedInputTheme(theme)),
        MuiPagination: __assign({}, PaginationTheme(theme)),
        MuiPaginationItem: __assign({}, PaginationItemTheme(theme)),
        MuiPaper: __assign({}, PaperTheme(theme)),
        MuiPopover: __assign({}, PopoverTheme(theme)),
        MuiPopper: __assign({}, PopperTheme(theme)),
        MuiRadio: __assign({}, RadioTheme(theme)),
        MuiRadioGroup: __assign({}, RadioGroupTheme(theme)),
        MuiRating: __assign({}, RatingTheme(theme)),
        MuiSelect: __assign({}, SelectTheme(theme)),
        MuiSkeleton: __assign({}, SkeletonTheme(theme)),
        MuiSpeedDial: __assign({}, SpeedDialTheme(theme)),
        MuiSpeedDialAction: __assign({}, SpeedDialActionTheme(theme)),
        MuiSpeedDialIcon: __assign({}, SpeedDialIconTheme(theme)),
        MuiSnackbar: __assign({}, SnackbarTheme(theme)),
        MuiSnackbarContent: __assign({}, SnackbarContentTheme(theme)),
        MuiSlider: __assign({}, SliderTheme(theme)),
        MuiStack: __assign({}, StackTheme(theme)),
        MuiStep: __assign({}, StepTheme(theme)),
        MuiStepButton: __assign({}, StepButtonTheme(theme)),
        MuiStepConnector: __assign({}, StepConnectorTheme(theme)),
        MuiStepContent: __assign({}, StepContentTheme(theme)),
        MuiStepIcon: __assign({}, StepIconTheme(theme)),
        MuiStepLabel: __assign({}, StepLabelTheme(theme)),
        MuiStepper: __assign({}, StepperTheme(theme)),
        MuiSvgIcon: __assign({}, SvgIconTheme(theme)),
        MuiSwitch: __assign({}, SwitchTheme(theme)),
        MuiSwipeableDrawer: __assign({}, SwipeableDrawerTheme(theme)),
        MuiTextField: __assign({}, TextFieldTheme(theme)),
        MuiTab: __assign({}, TabTheme(theme)),
        MuiTabs: __assign({}, TabsTheme(theme)),
        MuiTable: __assign({}, TableTheme(theme)),
        MuiTableBody: __assign({}, TableBodyTheme(theme)),
        MuiTableCell: __assign({}, TableCellTheme(theme)),
        MuiTableContainer: __assign({}, TableContainerTheme(theme)),
        MuiTableFooter: __assign({}, TableFooterTheme(theme)),
        MuiTableHead: __assign({}, TableHeadTheme(theme)),
        MuiTablePagination: __assign({}, TablePaginationTheme(theme)),
        MuiTableRow: __assign({}, TableRowTheme(theme)),
        MuiTableSortLabel: __assign({}, TableSortLabelTheme(theme)),
        MuiToggleButton: __assign({}, ToggleButtonTheme(theme)),
        MuiToggleButtonGroup: __assign({}, ToggleButtonGroupTheme(theme)),
        MuiToolbar: __assign({}, ToolbarTheme(theme)),
        // MuiTooltip: { ...TooltipTheme(theme) },
        MuiTypography: __assign({}, TypographyTheme(theme)),
        MuiCssBaseline: {
            styleOverrides: function () { return ({
                '::-webkit-scrollbar': {
                    width: 6,
                },
                '::-webkit-scrollbar-thumb ': {
                    borderRadius: 3,
                    backgroundColor: alpha(theme.palette.greySecondary.main, 0.14),
                },
            }); },
        },
    };
};
export var overrideTheme = __assign(__assign({}, defaultTheme), { components: __assign({}, overrideComponents(defaultTheme)) });
// Create a theme instance.
export var theme = createTheme(overrideTheme);
// process.env.NODE_ENV !== `production` &&
//   console.log(theme, '===================theme');
//# sourceMappingURL=theme.js.map